/**
 * Created by XUQIANG on 2017/5/23.
 */
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Menu from './Menu';
import Top from './Top';
import './Menu.less';
import {PATH_HOME, PATHS} from "../../utils/constants";

export default connect(state => state)(
  injectIntl(
    ({
      children,
      menu: menuData,
      dispatch,
      login,
      i18n,
      top: topData,
      location,
      intl
    }) => {

      let menuName = '';
      const {pathname,menus} = menuData;
      let newpath = pathname;
      if (pathname === PATHS.meetingInfo) {
        const { meetingId } = location.query;
        newpath = meetingId ? PATHS.list : PATHS.meeting;
      }
      if(menus && menus.status == 0){
        for(let menu of menus.data){
          if(`${PATH_HOME}${menu.url}` == newpath){
            menuName = menu.name;
          }else{
            if(menu.children){
              if(menu.children.some(x=>`${PATH_HOME}${x.url}` == newpath )){
                menuName = menu.name
              }
            }
          }
        }
      }
      const { userInfo } = login;
      return (
        <div className={'main-flex bg-cont'}>
          <Menu
            menuData={menuData}
            dispatch={dispatch}
            location={location}
            userInfo={userInfo}
            intl={intl}
          />
          <div className={'main-flex-top'}>
            <Top
              intl={intl}
              menuData={menuData}
              locale={i18n.locale}
              dispatch={dispatch}
              userInfo={userInfo}
              pathname={location.pathname}
            />
          </div>
          <div className={'main-flex-top-separate-header'} style={menuData.inlineCollapsed?{marginLeft:"65px"}:{}}>
            <span>{menuName && intl.formatMessage({ id:menuName })}</span>
          </div>
          <div className={'main-flex-center main-container'} style={menuData.inlineCollapsed?{marginLeft:"55px"}:{}}>
            {/*<div className="container-header">{menuData.showMenuName}</div>*/}
            <div className="container">{children}</div>
          </div>
        </div>
      );
    }
  )
);



// WEBPACK FOOTER //
// ./src/components/layout/Main.js